class NotificationAction {
  constructor(
    id,
    notificationGroupIdList,
    delay,
    repeatEnabled,
    maxReminders,
    repeatInterval,
    quietTimeId,
    templateId,
    maxRepeatEnabled = false,
  ) {
    this.id = id;
    this.notificationGroupIdList = notificationGroupIdList;
    this.delay = delay;
    this.repeatEnabled = repeatEnabled;
    this.maxReminders = maxReminders;
    this.repeatInterval = repeatInterval;
    this.quietTimeId = quietTimeId;
    this.templateId = templateId;
    this.maxRepeatEnabled = maxRepeatEnabled;
  }
}
export default NotificationAction;
